import BttfAxios from "@features/utils/axios";
import axios, { AxiosResponse } from "axios";
import PitchMockService from "@mocks/Pitch.mock.service";
import { IPitch } from "@appInterfaces/pitch.interfaces";
import { mockServerResponse } from "@mocks/mockServerResponse";

export type PitchStatus =
  | "Application"
  | "Draft"
  | "Pending"
  | "Live unlisted"
  | "Live listed"
  | "Finished"
  | "Post process"
  | "Closed"
  | "Exited"
  | "Refunded"
  | "Rejected";

export type Pitch = {
  id: number;
  slug: string;
  title?: string;
  image: string;
  time_remaining: number;
  status?: PitchStatus;
  specialisation_type: string;
  pitch_date: string;
  number_of_investors: number;
  raised_percent: string;
  raised_amount: string;
  expected_amount: number;
  company_name: string;
};

type PitchesWithPagination = {
  pagination: {
    page: number;
    per_page: number;
    total_count: number;
    total_pages: number;
  };
  pitches: Pitch[];
};

class PitchesClass {
  private config = { headers: { "Cache-Control": "no-cache" } };

  public getPitch(pitchIds: number | number[]): Promise<AxiosResponse<IPitch>> {
    return BttfAxios.get(`/api/pitches?id=${pitchIds}`, () =>
      mockServerResponse(PitchMockService.getPitches()).then((resp) => resp)
    );
  }

  public getPitches({
    page,
    search_phrase,
  }: {
    page?: number;
    search_phrase?: string;
  }): Promise<AxiosResponse<PitchesWithPagination>> {
    const params = new URLSearchParams();
    if (page !== undefined) params.append("page", String(page));
    if (search_phrase) params.append("search_phrase", search_phrase);

    return axios.get(`/api/pitches?${params.toString()}`, this.config);
  }
}
const PitchesService = new PitchesClass();

export default PitchesService;
